import { Trans } from 'react-i18next';

import { useMeasurement } from '@/hooks/useMeasurement';

import Super from './Super';

const SuperUnit = ({ unit }: { unit: string }) => {
  const { tunit } = useMeasurement();

  return (
    <Trans i18nKey={tunit(unit)}>
      <Super />
    </Trans>
  );
};

export default SuperUnit;
